import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { toggleDialog } from '../../store/control/duck';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { SlideTransition } from '../Transition/Transition';
import { tryTranslate } from '../../utils/locale';
import { makeStyles } from 'tss-react/mui';
const useStyle = makeStyles()({
  dialogContent: {
    width: '100%',
    position: 'relative',
    alignItems: 'center',
    marginBottom: 16
  },
  imageContainer: {
    width: '100%',
    '& img': {
      width: '100%',
      maxHeight: '30vh',
      objectFit: 'cover',
      objectPosition: 'top'
    }
  },
  imageOverlay: {
    position: 'absolute',
    bottom: -5,
    left: 0,
    width: '100%',
    height: '15%',
    background:
      'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 75% , rgba(255,255,255,1) 100%)',
    pointerEvents: 'none'
  }
});

const PermissionDialog = props => {
  const { intl, permissionDialog, toggleDialog } = props;
  const { intlId, onClose, closed, previewImage, title, actions, cta } = permissionDialog || {};

  const close = () => {
    toggleDialog('permission', { ...permissionDialog, closed: true });
    if (onClose) {
      onClose();
    }
  };
  const onExited = () => toggleDialog('permission', false);
  const { classes } = useStyle();

  return (
    <Dialog
      open={!!permissionDialog && !closed}
      fullWidth={true}
      slots={{
        transition: SlideTransition
      }}
      slotProps={{
        transition: {
          onExited: onExited
        }
      }}
    >
      <DialogTitle>{intl.formatMessage({ id: title || 'permission-dialog-title' })}</DialogTitle>
      <DialogContent>
        {previewImage && (
          <Box className={classes.dialogContent}>
            <Box className={classes.imageContainer}>
              {/* <Box className={classes.imageOverlay} /> */}
              <img src={previewImage} alt="wallet_banner_old" />
            </Box>
          </Box>
        )}
        <Fragment>{tryTranslate(intl, intlId)}</Fragment>
      </DialogContent>
      <DialogActions>
        {actions?.map((action, index) => (
          <Button key={index} color="primary" onClick={action.onClick}>
            {intl.formatMessage({ id: action.cta })}
          </Button>
        ))}
        <Button color="primary" onClick={close}>
          {intl.formatMessage({ id: cta || 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const container = connect(
  state => ({
    permissionDialog: state.control.permissionDialog
  }),
  {
    toggleDialog
  }
)(PermissionDialog);

export default injectIntl(container);
